module.exports = __webpack_public_path__ + "img/visual1.553aecd2.png";